import type { PropsWithChildren } from "react";
import { useMemo } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { Helmet } from "react-helmet";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { ControlledThemeProvider } from "@circle-react/providers";
import { reactQueryConfig } from "@circle-react/providers/QueryClient/reactQueryConfig";

interface CheckoutWrapperProps {
  title: string;
}

export const CheckoutWrapper = Object.assign(
  ({ title, children }: PropsWithChildren<CheckoutWrapperProps>) => {
    const queryClient = useMemo(() => new QueryClient(reactQueryConfig), []);

    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Router>
          <ControlledThemeProvider>
            <QueryClientProvider client={queryClient}>
              <NiceModal.Provider>{children}</NiceModal.Provider>
            </QueryClientProvider>
          </ControlledThemeProvider>
        </Router>
      </>
    );
  },
  {
    Preview: ({ children }: PropsWithChildren<Record<string, unknown>>) => (
      <ControlledThemeProvider>{children}</ControlledThemeProvider>
    ),
  },
);
